import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { AlertTriangle, Calculator, Clock, Users } from 'lucide-react'
import type { ImpuestosPageStats } from '@/hooks/useImpuestosPage'

interface ImpuestosStatsProps {
  stats: ImpuestosPageStats
  isLoading?: boolean
}

export function ImpuestosStats({ stats, isLoading = false }: ImpuestosStatsProps) {
  const cards = [
    {
      title: 'Total Impuestos',
      value: stats.total_impuestos,
      icon: Calculator,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
      description: 'Activos en catálogo',
    },
    {
      title: 'Clientes c/Impuestos',
      value: stats.total_clientes_con_impuestos,
      icon: Users,
      color: 'text-green-600',
      bgColor: 'bg-green-100',
      description: 'Con al menos 1 impuesto',
    },
    {
      title: 'Pendientes',
      value: stats.pendientes_este_mes,
      icon: Clock,
      color: 'text-orange-600',
      bgColor: 'bg-orange-100',
      description: 'Este mes',
    },
    {
      title: 'Vencidos',
      value: stats.vencidos,
      icon: AlertTriangle,
      color: 'text-red-600',
      bgColor: 'bg-red-100',
      description: 'Requieren atención',
    },
  ]

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <div className="h-4 w-24 bg-muted animate-pulse rounded" />
              <div className="h-8 w-8 bg-muted animate-pulse rounded" />
            </CardHeader>
            <CardContent>
              <div className="h-7 w-16 bg-muted animate-pulse rounded mb-1" />
              <div className="h-3 w-20 bg-muted animate-pulse rounded" />
            </CardContent>
          </Card>
        ))}
      </div>
    )
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {card.title}
            </CardTitle>
            <div className={`p-2 rounded-lg ${card.bgColor}`}>
              <card.icon className={`h-4 w-4 ${card.color}`} />
            </div>
          </CardHeader>
          <CardContent>
            <div
              className={`text-2xl font-bold ${card.title === 'Vencidos' && card.value > 0 ? 'text-red-600' : ''}`}
            >
              {card.value}
            </div>
            <p className="text-xs text-muted-foreground">{card.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
